import script from "./ProcedureInviteMembers.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcedureInviteMembers.vue?vue&type=script&setup=true&lang=js"

import "./ProcedureInviteMembers.vue?vue&type=style&index=0&id=fefd1d36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fefd1d36"]])

export default __exports__